<template>
  <v-row no-gutters>
    <v-col>
  <v-stepper v-model="stepper" vertical>
    <v-stepper-step :complete="stepper > 1" step="1" :editable="true">
      UPLOAD
      <small>Upload a file with portfolio constituents and dates</small>
    </v-stepper-step>
    <v-stepper-content step="1" >
      <v-row no-gutters>
        <v-col cols="12">
          <div class="ml-5">
            <p class="mt-5 mb-1 font-weight-medium">Please upload a file (csv only)</p>
            <p class="font-weight-light body-2">Date | Ticker, RIC or ISIN | Quantity or weight</p>
          </div>
          <v-card class="mt-8">
            <v-container fluid class="pa-5">
              <v-row>
                  <v-file-input
                    ref="myid_fileinput" id="id_fileinput"
                    v-model="fileName"
                    accept=".csv"
                    placeholder="Pick a file"
                    prepend-icon="mdi-file"
                    label="File"
                  ></v-file-input>
              </v-row>  
              <v-row>
                <v-btn color="primary" @click="sendToS3" :loading="isLoading">Upload File</v-btn>
                <span v-if="showTooltip">
                  <small>Please specify a file</small>
                </span>                
              </v-row>
              <v-row v-if="responseUploadError !== null">
                Error: We could not upload the file.
              </v-row>                       
            </v-container>
          </v-card>
        </v-col>
      </v-row> 
    </v-stepper-content>

    <v-stepper-step :complete="stepper > 2" step="2">
      CONFIRM COLUMNS
      <small>Select stock ids and quantity/weighting columns</small>
      </v-stepper-step>
    <v-stepper-content step="2">
      <v-container fluid class="pa-5">
      <v-row no-gutters v-if='responseCheck'>
        Please confirm the detected columns: date, id and quantity/weight<br>
        <v-row >
          <v-col cols="4">
            Date column
          </v-col>              
          <v-col cols="8">
            <v-select
              v-model="matchingDate.file"
              label="Date col"
              :items="header"
              item-text="text"
              item-value="value"            
              dense
            ></v-select>
          </v-col>
        </v-row>  
        <v-row >
          <v-col cols="4">
            Id col
          </v-col>              
          <v-col cols="4">
            <v-select
              v-model="matchingId.file"
              label="File id col"
              :items="header"
              item-text="text"
              item-value="value"            
              dense
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-select
              v-model="matchingId.matching"                
              label="Type"                
              :items="selectOptionsId"
              item-text="text"
              item-value="value"            
              dense
            ></v-select>
          </v-col>
        </v-row>     
        <v-row >
          <v-col cols="4">
            Quantity/Weight col
          </v-col>              
          <v-col cols="4">
            <v-select
              v-model="matchingWgt.file"                
              label="File qty/wgt col"
              :items="header"
              item-text="text"
              item-value="value"            
              dense
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-select
              v-model="matchingWgt.matching"
              placeholder = "?"                
              label="Type"                
              :items="selectOptionsWgt"
              item-text="text"
              item-value="value"           
              dense
            ></v-select>
          </v-col>
        </v-row>                    
        <v-row no-gutters >
          <v-col>
            <v-data-table
              :disable-sort="true"
              v-show="responseCheck"
              :headers="header"
              :items="items"
              :items-per-page="5"
              dense
              :mobile-breakpoint="0"
            >
            </v-data-table>
          </v-col>
        </v-row>
        <v-row >
          <v-btn color="primary" @click="uploadPortfolio" :loading="isLoadingUpload">Upload Portfolio</v-btn>
        </v-row>                 
      </v-row>
      <v-row v-if='responseError'>
          <br>    
          No table could be extracted for the following reason(s):
          <br> {{responseUpload}}         
      </v-row>  
      </v-container>
    </v-stepper-content>

    <v-stepper-step :complete="stepper > 3" step="3">
      MATCH STOCKS
      <small>Make sure all stock ids are matched</small>
    </v-stepper-step>
    <v-stepper-content step="3">
        <v-alert color='#F44336' v-if="itemsMissing.length!=0">
          The following stocks could not be matched with our system: {{itemsMissing}}
        </v-alert>
        <v-alert color='#F44336' v-if="itemsDatesExisting.length!=0">
          Saving these constituents will erase existing portfolio for date(s): {{itemsDatesExisting}}
        </v-alert>        
        <v-alert type='success' dark color="#009688" v-if="itemsMissing.length===0 & itemsDatesExisting.length===0">
          All stocks were successfully matched.
        </v-alert>
        <v-data-table
          :headers="headerStep3"
          :items="itemsMatched"
          :mobile-breakpoint="0"
        >
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.date }}</td>
              <td>{{ row.item.name }}</td>
              <td>{{ row.item.ticker }}</td>                  
              <td>{{ row.item.ric }}</td>                  
              <td>{{ row.item.quantity | numeral('0.[00]%') }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-btn color="primary" @click="$emit('portfolioFileUploaded',{portfolio:itemsMatched})">Save Constituents</v-btn>
    </v-stepper-content>
    <!-- 
    <v-stepper-step :complete="stepper > 4" step="4">
      RESULT OF DATABASE UPLOAD
      <small>Result of constituents upload</small>
    </v-stepper-step>
    <v-stepper-content step="4">
      Success or Error        
    </v-stepper-content> -->
  </v-stepper>    

    </v-col>

    <v-snackbar :timeout="0" :color="snackbar.color" v-model="snackbar.isOpen">
      {{ snackbar.text }}

      <v-btn
        small
        dark
        icon
        @click="snackbar.isOpen = false"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
//import axios from 'axios'
//const MAX_FILE_SIZE = 5000000
//const AWS = require('aws-sdk')
//const s3 = new AWS.S3()
//import vue2Dropzone from 'vue2-dropzone'
//import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'FileUploader',
  props:{
    id: {
      type: String,
      required: false
    }   
  },
  data () {
    return {       
      stepper: 1,
      file: '',
      uploadURL: '',
      fileName:null,
      responseUpload:null,
      selectConstituentsDate: null,  
      isLoading:false,  
      isLoadingUpload:false,        
      responseCheck: false,   
      responseError:false,
      items:[],
      header:[],
      headerStep3: [
          { text: 'Date', value: 'date' },
          { text: 'Name', value: 'name' },
          { text: 'Ticker', value: 'ticker' },
          { text: 'RIC', value: 'ric' },
          { text: 'Quantity', value: 'quantity' },
        ],
      matching: null,
      selectOptions: null,
      selectOptionsId: null,
      selectOptionsWgt: null,
      dateConstituents:null,
      panel:[0],
      itemsMatched:[],
      itemsMissing:[],
      itemsDatesExisting:[],
      responseUploadError:null,
      showTooltip:false,
      snackbar: {
        text: "",
        isOpen: false,
        color: "green",
      },
    }
  },
  methods: {
    updateColSelection(col_key){
      // Check if selection is an id or weight  
      if (this.matching[col_key]== null) {
        return 1
      }
      else if ( (this.selectOptionsId.map(x=> x['value'])).includes(this.matching[col_key])  ){
        // New value is an id
        for (var key in this.matching) {
            // check if the property/key is defined in the object itself, not in parent
            if (key != col_key & (this.selectOptionsId.map(x=> x['value'])).includes(this.matching[key])) {           
                this.matching[key]=null;
            }
        }        
      } 
      else if ((this.selectOptionsWgt.map(x=> x['value'])).includes(this.matching[col_key])  ){  
        for (var keywgt in this.matching) {
            // check if the property/key is defined in the object itself, not in parent
            if (keywgt != col_key & (this.selectOptionsWgt.map(x=> x['value'])).includes(this.matching[keywgt])) {           
                this.matching[keywgt]=null;
            }
        }                 
      }
      return 1
    },
    // sendFile(){
    //   if (typeof this.fileName !== 'undefined' & this.fileName!='' & this.fileName!= null){
    //     let reader = new FileReader()
    //     reader.onload = (e) => {
    //       console.log(e.target.result)
    //       if (e.target.result.length > MAX_FILE_SIZE) {
    //         return alert('File is loo large - 5Mb maximum')
    //       }
    //       this.file = e.target.result;
    //       this.sendToS3();
    //     }
    //     reader.readAsDataURL(this.fileName);        

    //   } 
    // },
    async sendToS3() {

      if (typeof this.fileName === 'undefined' | this.fileName==='' | this.fileName=== null){
        this.showTooltip=true;
        return 1;
      }
      var self = this
      self.responseUpload = null;
      self.isLoading=true;
      self.responseUploadError=null;
      self.responseCheck= false;
      self.responseError= false;
      const currentSession = await this.$Amplify.Auth.currentSession()
      const currentToken = currentSession.getIdToken().getJwtToken()
      //console.log({file: this.fileName.name});
      this.$http.post(process.env.VUE_APP_API_HOST + '/get-s3-presigned-url/' + this.id,{file: this.fileName.name},{
        headers: {
          'Authorization': currentToken
        }
      }).then(function (response) {
        //console.log(response.data.signed_url);
        self.sendFileToS3(response.data.signed_url);
      }).catch(function (error) {
        self.responseUploadError = error; //.response.data.error;        
        //console.log(error);
        self.isLoading = false
      })    
    }, 
    // async getS3url() {
    //   const currentSession = await this.$Amplify.Auth.currentSession()
    //   const currentToken = currentSession.getIdToken().getJwtToken()
    //   console.log(this.fileName);
    //   return this.$http.post(process.env.VUE_APP_API_HOST + '/get-s3-presigned-url/' + this.id,{file: this.fileName.name},{
    //     headers: {
    //       'Authorization': currentToken,
    //     }
    //   }).then(function (response) {
    //     console.log(response.data.signed_url);
    //     return(response.data.signed_url);
    //   }).catch(function () {
    //     return null
    //   })  
    // }, 
    async sendFileToS3(presigned_post) {
        var self = this
        var postData = new FormData(); //its type to JS inbuilt form
        for(var key in presigned_post.fields){ //appending all keys sent by django to our JS FormData object
              postData.append(key, presigned_post.fields[key]);
        }
        //var file=document.getElementById('id_fileinput').files[0]; //id_inputButtonReal is id of HTML input element
        postData.append('file', this.fileName);
        //console.log(file)
        //console.log(this.fileName);
        //console.log(presigned_post.url)
        this.$http.post(presigned_post.url,postData,{
          headers: {
            "Content-Type": "multipart/form-data"
          }          
        }).then(function (/*response*/) {
          //self.responseUploadError = response
          self.sendToAPIparser(self.fileName.name)
        }).catch(function (error) {
          //console.log("error")
          self.responseUploadError = error; //.response.data.error;        
          self.isLoading = false
          //console.log(error);
        })    
    },     
    // async sendFileToS3(path) {
    //   //console.log(path)
    //   let reader = new FileReader();
    //   reader.onload = (e) => {
    //     this.file = e.target.result;

    //     this.$http.put(path,{'file':this.file},{
    //       headers: {
    //         'Content-Type': 'multipart/form-data'
    //       }
    //     }).then(function (response) {
    //       self.responseUploadError = response
    //       //console.log(response)
    //       //this.sendToAPIparser(path)
    //     }).catch(function (error) {
    //       self.responseUploadError = error; //.response.data.error;        
    //       //console.log(error);
    //     }).finally(() => (this.isLoading = false))    
    //   }
    //   reader.readAsDataURL(this.fileName); 
    // },     
    
    async sendToAPIparser(fileName) {
      var self = this
      //console.log("sendToAPIparser")
      self.responseUpload = null;
      self.isLoading=true;
      self.responseCheck= false;
      self.responseError= false;
      const currentSession = await this.$Amplify.Auth.currentSession()
      const currentToken = currentSession.getIdToken().getJwtToken()
      //console.log({file: this.file});
      this.$http.post(process.env.VUE_APP_API_HOST + '/upsert-portfolio-from-file/' + this.id,{file: fileName},{
        headers: {
          'Authorization': currentToken,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        self.responseUpload = response.data
        self.items = response.data.constituents
        self.header = response.data.header
        self.matching = response.data.matching;
        self.selectOptionsId = response.data.selectOptionsId;      
        self.selectOptionsWgt = response.data.selectOptionsWgt;      
        self.selectOptionsDate = response.data.selectOptionsDate; 
        self.selectOptions = self.selectOptionsId.concat(self.selectOptionsWgt);      
        self.dateConstituents = response.data.dateConstituents;              
        self.matchingId = response.data.matchingId;   
        self.matchingWgt = response.data.matchingWgt;
        self.matchingDate = response.data.matchingDate;                   
        self.responseCheck= true;
        self.responseError= false;
        self.panel=[1];     
        self.stepper = 2;   
      }).catch(function (error) {
        self.responseUpload = error.response.data.error; 
        self.responseCheck= false;
        self.responseError= true;        
        self.items = []
        self.header = []
        self.matching = null;
        self.selectOptions = null;   
        self.selectOptionsId = null;      
        self.selectOptionsWgt = null;
        self.selectOptionsDate =null;              
        self.dateConstituents=null;
        self.matchingId = null;   
        self.matchingWgt = null;  
        self.matchingDate = null;                 
        self.panel=[1] ;   
        self.stepper = 2;      
      }).finally(() => (self.isLoading = false))    
    },     
    uploadPortfolio() {
      if ( !(this.matchingId.file &&  this.matchingId.matching) ){
        this.displaySnackbar({
          text: 'Please define the matching between your portfolio and the id type.',
          color: 'red'
        })
        return
      }
      if ( !(this.matchingWgt.file &&  this.matchingWgt.matching) ){
        this.displaySnackbar({
          text: 'Please define the matching between your portfolio and the quantity/weight type.',
          color: 'red'
        })
        return
      }
      if ( !(this.matchingDate.file) ){
        this.displaySnackbar({ text: 'Please define the date column.', color: 'red'})
        return
      }

      let req = {
        matching: {
          id: this.matchingId,
          weight: this.matchingWgt,
          date: this.matchingDate
          }
        }
      this.sendToLambdaUpload(req);
    },
    async sendToLambdaUpload (req) {
      var self = this
      self.responseUpload = null;
      self.isLoadingUpload=true;
      //self.responseCheck= false;
      self.responseError= false;
      const currentSession = await this.$Amplify.Auth.currentSession()
      const currentToken = currentSession.getIdToken().getJwtToken()
      this.$http.post(process.env.VUE_APP_API_HOST + '/upsert-portfolio-from-file/' + this.id,req,{
        headers: {
          'Authorization': currentToken,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        self.itemsMatched = response.data.matched ;       
        self.itemsMissing = response.data.missing;        
        self.itemsDatesExisting = response.data.existing_dates; 
        self.panel=[2];     
        self.stepper = 3;   
      }).catch(function (error) {
        self.itemsMatched = [] ;       
        self.itemsMissing = [];         
        self.itemsDatesExisting= [];
        self.responseError= true;
        self.responseUpload = error.response.data.error; 
     
      }).finally(() => (this.isLoadingUpload = false))    
    },
    displaySnackbar({ text, color }) {
      this.snackbar = {
        text,
        color,
        isOpen: true,
      };
    },
  }
}
</script>